import { SectionHeadingSkeleton } from '../headers';
import PhoneNumberLoading from '../inputs/phone-number/loading';

export function Loading() {
  return (
    <div className="3xl:pr-8 pr-6">
      <SectionHeadingSkeleton />
      <PhoneNumberLoading />
    </div>
  );
}
